import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../modal';
import InsertMacros from '../../insert-macros';
import LocalizationConsumer from '../../../l10n/localization-context';

class InsertMacrosDialog extends React.Component
{
  static propTypes = {
    macros: PropTypes.arrayOf(PropTypes.shape({})),
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    endpoint: PropTypes.string.isRequired
  };

  state =
  {
    macros: [],
    checkedMacros: [],
    isSaveButtonDisabled: true
  };

  getButtons = () =>
  {
    const { onSave, onCancel } = this.props;
    const { isSaveButtonDisabled } = this.state;

    const saveStateValue = () =>
    {
      onSave(this.state.checkedMacros);
      this.setState({ checkedMacros: [], isSaveButtonDisabled: true });
    };

    return [
      {
        name: <LocalizationConsumer id="insert-macros-dialog.button-save" />,
        buttonHandler: saveStateValue,
        isDisabled: isSaveButtonDisabled
      },
      {
        name: <LocalizationConsumer id="insert-macros-dialog.button-cancel" />,
        buttonHandler: onCancel
      }
    ];
  };

  handleMacrosChange = value => () =>
  {
    const checkedMacros = [...this.state.checkedMacros];

    const valueIndex = checkedMacros.indexOf(value);

    if (valueIndex === -1)
    {
      checkedMacros.push(value);
    }
    else
    {
      checkedMacros.splice(valueIndex, 1);
    }

    this.setState(
      {
        checkedMacros,
        isSaveButtonDisabled: checkedMacros.length === 0
      });
  };

  render()
  {
    const { onCancel, endpoint, macros } = this.props;
    const { checkedMacros } = this.state;

    return (
      <Modal
        onCloseDialogClick={onCancel}
        size={{ width: 580, height: 520 }}
      >
        <Modal.Header>
          <LocalizationConsumer id="insert-macros-dialog.header" />
        </Modal.Header>
        <Modal.Content>
          <InsertMacros
            macros={macros}
            endpoint={endpoint}
            checkedMacros={checkedMacros}
            onMacrosChange={this.handleMacrosChange}
          />
        </Modal.Content>
        <Modal.Footer>
          {this.getButtons()}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default InsertMacrosDialog;
